export default "__VITE_ASSET__dd714dba__"